module.exports = __webpack_public_path__ + "img/csb_logo_en.7fb7ac4c.gif";